<script lang="ts">
	import type { PoiCardFactory } from './types';
	import Icon from '$lib/components/icons/Icon.svelte';
	import RepeatIcons from '$lib/components/icons/RepeatIcons.svelte';
	import EvStationFragment from '$lib/components/pois/card/evStation/EVStationFragment.svelte';
	import GasStationFragment from '$lib/components/pois/card/gasStation/GasStationFragment.svelte';
	import PoiCardFooter from '$lib/components/pois/card/poiCardFooter/PoiCardFooter.svelte';
	import PoiCardHero from '$lib/components/pois/card/poiCardHero/PoiCardHero.svelte';
	import PoiCardTemplate from '$lib/components/pois/card/PoiCardTemplate.svelte';
	import PoiCardTitle from '$lib/components/pois/card/poiCardTitle/PoiCardTitle.svelte';
	import RestStopFragment from '$lib/components/pois/card/restStop/RestStopFragment.svelte';

	interface Props {
		cardProps?: PoiCardFactory;
		layout?: 'vertical' | 'horizontal';
		isHovered?: boolean;
		onmouseenter?: (event: MouseEvent) => void;
		onmouseleave?: (event: MouseEvent) => void;
		onAddItineraryClick?: () => void;
		onBookClick?: () => void;
		onCardClick?: (event: MouseEvent) => void;
	}

	const {
		cardProps,
		layout = 'vertical',
		isHovered,
		onmouseenter,
		onmouseleave,
		onAddItineraryClick,
		onBookClick,
		onCardClick,
	}: Props = $props();
</script>

{#if cardProps}
	<PoiCardTemplate
		href={cardProps.href}
		tag={cardProps.tag}
		class={[cardProps.size, cardProps.classes]}
		dataTestId={`poi-card-${cardProps.index}`}
		category={cardProps.scheme}
		{isHovered}
		{onmouseenter}
		{onmouseleave}
		{onCardClick}
		{layout}
	>
		{#snippet content()}
			{#if cardProps.hero}
				<PoiCardHero {...cardProps.hero} {layout} />
			{/if}
			<div class={[cardProps.hero ? 'pt-1' : 'pt-2', 'px-2 pb-0 grid h-max']}>
				{#if cardProps.content}

					{#if cardProps.content.title}
						<PoiCardTitle {...cardProps.content.title} />
					{/if}

					{#if cardProps.content.distinction}
						<div
							class="flex flex-row items-center pbe-1">
							{#if cardProps.content.distinction?.repeatedIcon}
								<RepeatIcons {...cardProps.content.distinction.repeatedIcon} />
							{/if}
							{#if cardProps.content.distinction?.icon}
								<Icon {...cardProps.content.distinction.icon} />
							{/if}
						</div>
					{/if}

					{#if cardProps.content.city}
						<span class="truncate font-400 text-sm text-coloredneutral-soft p-be-1px">{cardProps.content.city}</span>
					{/if}

					{#if cardProps.content.distanceFromLocation}
						<span class="truncate font-400 text-sm text-coloredneutral-soft">
							{cardProps.content.distanceFromLocation.distance} {cardProps.content.distanceFromLocation.unit}
						</span>
					{/if}

					{#if cardProps.content.gasStation}
						<GasStationFragment {...cardProps.content.gasStation} />
					{/if}
					{#if cardProps.content.evStation}
						<EvStationFragment {...cardProps.content.evStation} />
					{/if}

					{#if cardProps.content.restStop}
						<RestStopFragment {...cardProps.content.restStop} />
					{/if}
				{/if}
			</div>
		{/snippet}
		{#snippet footer()}
			<PoiCardFooter
				{...cardProps.footer}
				{onAddItineraryClick}
				{onBookClick}
			/>
		{/snippet}
	</PoiCardTemplate>
{/if}
